import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lable",
  "use": "icon-lable-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lable\"><defs><style type=\"text/css\"></style></defs><path d=\"M320 896c64 0 96-74.88 96-128V192H270.72a96 96 0 0 0-94.08 77.12L160 352H96V128a64 64 0 0 1 64-64h704a64 64 0 0 1 64 64v224h-64l-16.64-82.88A96 96 0 0 0 753.28 192H608v576c0 53.12 32 128 96 128v64H320z\" fill=\"#231F20\" p-id=\"3211\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol